// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import aisEntity from './entities/ais.json';
import aisMenu from '../pages/ais/menu.json';
import aisFullForm from '../pages/ais/forms/full.json';
import aisContextForm from '../pages/ais/forms/context.json';
import aisMiniForm from '../pages/ais/forms/mini.json';
import aisLookupForm from '../pages/ais/forms/lookup.json';
import aisTableView from '../pages/ais/views/table.json';
import aisStagesView from '../pages/ais/views/stages.json';
import aisCardsView from '../pages/ais/views/cards.json';
import aisInlineView from '../pages/ais/views/inline.json';
import aisBacklogView from '../pages/ais/views/backlog.json';
import aisSplitView from '../pages/ais/views/split.json';
import aisCalendarView from '../pages/ais/views/calendar.json';
import aisDashboardView from '../pages/ais/views/dashboard.json';

/** Тип запису «Навичка» зі сторінками пакета: меню, форми та подання з pages/ais/. */
export const aisDefinition: IRecordTypeDefinition = {
  ...aisEntity,
  views: assembleViewSet({
      table: aisTableView,
      stages: aisStagesView,
      cards: aisCardsView,
      inline: aisInlineView,
      backlog: aisBacklogView,
      split: aisSplitView,
      calendar: aisCalendarView,
      dashboard: aisDashboardView,
  }),
  form: aisFullForm,
  forms: { full: aisFullForm, context: aisContextForm, mini: aisMiniForm, lookup: aisLookupForm },
  menu: aisMenu,
} as IRecordTypeDefinition;
